import React from 'react';
import {Box} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import useApiGetWeightByYear from "./api-hooks/useApiGetWeightByYear";
import LabelledMuiTypography from "../../../../../../ui/mui/mui-display-data/LabelledMuiTypography";
import OnCloseTable from "../../../../../../ui/common_components/OnCloseTable";
import {formatIntegerToLocale} from "../../../../../../../logics/helpers";

interface Props {
    onClose?: () => void;
}


const WeightByYearCard = ({onClose}: Props) => {
    const theme = useTheme();
    const fontSize = 18;

    const {data, isLoading} = useApiGetWeightByYear();

    const rows = Array.isArray(data) ? data : (data ? [data] : []);
    

    return (
        <>
            {onClose && <OnCloseTable onClose={onClose}/>}
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
                border: '1px solid lightgrey',
                borderRadius: '4px',
                padding: '10px',
                backgroundColor: theme.palette.backgroundAppGarageColor.main
            }}>
                {rows.map((item) => (
                    <LabelledMuiTypography
                        key={item.year}
                        label={item.year.toString()}
                        value={formatIntegerToLocale(item.total_weight) ?? ''}
                        upperCaseValue={true}
                        fontSize={fontSize}
                    />
                ))}
            </Box>
        </>
    );
}

export default WeightByYearCard;